import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { Quest } from '@models/quest';

@Directive({
  selector: '[zbpQuestLaunch]',
  standalone: false
})
export class QuestLaunchDirective {
  @Input() quest: Quest = null;
  @Input() isLinkableQuest: boolean = false;
  @Input() isSet: boolean = false;
  @Output() questLaunched: EventEmitter<Quest> = new EventEmitter<Quest>();

  @HostListener('click', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleClick(event: UIEvent): void {
    if (!this.quest.isComplete && this.isLinkableQuest && !this.isSet) {
      this.questLaunched.emit(this.quest);
    }
  }
}
